import { createSlice } from '@reduxjs/toolkit';

interface CampaignsState {
  campaigns: any[];
  loading: boolean;
}

const initialState: CampaignsState = {
  campaigns: [],
  loading: false,
};

const campaignsSlice = createSlice({
  name: 'campaigns',
  initialState,
  reducers: {
    setCampaigns: (state, action) => {
      state.campaigns = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const { setCampaigns, setLoading } = campaignsSlice.actions;
export default campaignsSlice.reducer;
